export default {
  outputTemplate: 'Modèle de message',
  createCategory: 'Ajouter une catégorie',
  createCategoryHelp: 'Appuyez sur <kbd>enter</kbd> pour enregistrer',
  availabilityState: '@:entity.availabilityState',
};
